import { ReactNode } from "react";

type SectionHeadingProps = {
  title: string;
  icon?: ReactNode;
  className?: string;
  showBorder?: boolean;
};

export function SectionHeading({
  title,
  icon,
  className = "",
  showBorder = true,
}: SectionHeadingProps) {
  return (
    <div className={`mb-6 flex items-start gap-2 ${showBorder ? "border-b border-gray-200 dark:border-gray-700 pb-3" : ""} ${className}`}>
      {icon && (
        <div className="flex-shrink-0 mt-0.5">
          {icon}
        </div>
      )}
      <h2 className="font-heading text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 dark:text-gray-100 leading-tight min-w-0">
        {title}
      </h2>
    </div>
  );
}
